import React, { useEffect, useState } from "react";

import styles from "./AddressResults.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import { ClipLoader } from "react-spinners";

import { api } from "../../../api/api";
import DataTable from "react-data-table-component";

function AddressSearchResultsModal(props) {
  const { searchValue, onSelect } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [addresses, setAddresses] = useState([]);

  //Table Config
  const columns = [
    {
      name: "ID",
      selector: (row) => row.addressId,
      style: {
        color: "#202124",
        fontSize: "14px",
        fontWeight: 500,
      },
    },
    {
      name: "Name",
      selector: (row) => row.name,
    },
    {
      name: "Postal Code",
      selector: (row) => row.zip,
    },
    {
      name: "Address",
      selector: (row) => row.address,
      width: "200px",
    },
    {
      name: "City",
      selector: (row) => row.city,
    },
    {
      name: "Province",
      selector: (row) => row.province,
    },
  ];

  const getData = async () => {
    setIsLoading(true);
    try {
      const fetchedBoxes = await api.get(
        `/address/searchAddress?search=${searchValue}`
      );
      setAddresses(fetchedBoxes?.data?.addresses);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();

    // eslint-disable-next-line
  }, [searchValue]);

  const customStyles = {
    responsiveWrapper: {
      style: {
        overflowY: "auto",
      },
    },

    headRow: {
      style: {
        border: "none",
      },
    },
    headCells: {
      style: {
        color: "white",
        backgroundColor: "#6f9be2",
        fontWeight: 600,
        fontSize: "16px",
      },
    },
    rows: {
      style: {
        borderBottomColor: "#FFFFFF",
      },
      highlightOnHoverStyle: {
        backgroundColor: "#bfcfea",
        borderBottomColor: "#FFFFFF",
      },
    },
  };

  return (
    <div className={styles.container}>
      <div>
        <div className={styles.heading}>
          <h3>Select Address (Double Click to Select)</h3>
          <FontAwesomeIcon
            style={{ cursor: "pointer" }}
            onClick={props.onClose}
            icon={faX}
          />
        </div>
        {isLoading && (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
              minHeight: "60vh",
              minWidth: "60vw",
            }}
          >
            <ClipLoader
              className={styles.loadingSpinner}
              loading={isLoading}
              color="#6f9be2"
              size={30}
            />
          </div>
        )}
        {!isLoading && (
          <div className={styles.results}>
            <DataTable
              className={styles.table}
              columns={columns}
              data={addresses}
              customStyles={customStyles}
              highlightOnHover
              onRowDoubleClicked={(row) => {
                onSelect(row);
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default AddressSearchResultsModal;
